import "./css/form.css";
import React, { useState } from "react";
// import DatePicker from "react-datepicker";
export default function Complaint(props) {
  const [name, setName] = useState("");
  const [pNumber, setPnumber] = useState("");
  const [aNumber, setAnumber] = useState("");
  const [brandName, setBrandName] = useState("");
  const [modal, setModal] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [pDate, setPdate] = useState("");
  const [Address, setAddress] = useState("");
  const [Issue, setIssue] = useState("");
  const [Pincode, setPincode] = useState("");
  const [typeOfComplaint, setTypeOfComplaint] = useState("");
  const [complaintNumber, setComplaintNumber] = useState("Pending");
  // const [reload,setReload] = useState();

  const OldDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth()).padStart(2, "0");
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
    
  };

  const handlePNumber = (event) => {
    (parseInt(event.target.value)?parseInt(event.target.value):0)<10000000000 && event.target.value.length<11 &&
    setPnumber(event.target.value);
  }

  function saveComplaint() {
    props.setProgress(10);

    let data = {
      typeOfComplaint,
      name,
      pNumber,
      aNumber,
      brandName,
      modal,
      serialNumber,
      pDate,
      Address,
      Issue,
      Pincode,
      complaintNumber,
      
    };

    if ( 
      typeOfComplaint!==""&&
      name!==""&&
      pNumber!==""&&
      aNumber!==""&&
      brandName!==""&&
      modal!==""&&
      serialNumber!==""&&
      pDate!==""&&
      Address!==""&&
      Pincode!==""&&
      complaintNumber!=="") {
        if(window.confirm("Your Data is Save")===true){
          window.location.reload('/complaintform')
          // e.target.reset();
          
          fetch(`${process.env.REACT_APP_NEWS_API}/api/users`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then((resp) => {

        // console.warn("resp",resp);;
        resp.json().then((result) => {
          //   console.warn("result",result)
        });
      });
      props.setProgress(100);
        }else{
          // window.location('/complaintform')
        }      
    } else  alert("Place Enter All Requied Fileds") ;
    
  }
  return (
    <>
      <div className="container">
        <form className="mt-1 form" data-confirm="Are you sure you want to submit the form?" >
          <h1
            style={{
              textAlign: "center",
              // background: "#ecf0f3",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            Complaint Form
          </h1>
          <div className="row">
          <div className="form-group col-md- mt-4">
              <label style={{textAlign:'center'}} htmlFor="Name">Entry Type:</label>
              <input
              list="browsers"
                type="text"
                name="typeOfComplaint"
                id="typeOfComplaint"
                value={typeOfComplaint}                
                onChange={(e) => {
                  setTypeOfComplaint(e.target.value);
                }}
                className="form-control input"
                placeholder="Enter Type Of Complaint"                
                required
              />     
             <datalist id="browsers">
                <option value="INSTALLATION"/>
                <option value="ISSUE"/>
                <option value="FAULTY"/>
                <option value="RE-INSTALLATION"/>                
              </datalist>         
            </div>
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Name">Name:</label>
              <input
                type="text"
                name="name"
                id="name"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                className="form-control input"
                placeholder="Enter Your Name"
                required
              />
            </div>
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Phone">Phone Number:</label>
              <input
                // pattern="^-?[0-9]\d*\.?\d*$"
                
                type="number"
                name="pNumber"
                id="pNumber"
        // pattern="[+-]?\d+(?:[.,]\d+)?"
                value={pNumber}
                // min="10000000000"
                // max="9999999999"                
                 min={1000000000}
                 max={9999999999}
                onChange={handlePNumber}
                className="form-control"
                placeholder="Enter Your Number"
                required
              />
            </div>
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Alternative">Alternative Number:</label>
              <input
                type="number"
                name="aNumber"
                id="aNumber"
                value={aNumber}
                onChange={(e) => {
                  setAnumber(e.target.value);
                }}
                className="form-control"
                placeholder="Enter Alternative Name"
                required
              />
            </div>
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Company">Product Company Name:</label>
              <input
                type="text"
                name="Company"
                value={brandName}
                onChange={(e) => {
                  setBrandName(e.target.value);
                }}
                className="form-control"
                placeholder="Enter Product Brand Name"
                required
              />
            </div>
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Model">Product Name:</label>
              <input
                type="text"
                name="modal"
                id="modal"
                value={modal}
                onChange={(e) => {
                  setModal(e.target.value);
                }}
                className="form-control"
                placeholder="Enter Product Name"
                required
              />
            </div>
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Serial">Serial Number:</label>
              <input
                type="text"
                name="serialNumber"
                id="serialNumber"
                value={serialNumber}
                onChange={(e) => {
                  setSerialNumber(e.target.value);
                }}
                className="form-control"
                placeholder="Enter Bill Number"
                required
              />
            </div>
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Date">Date Purchace:</label>
              <input
                type="date"
                name="pDate"
                id="pDate"
                value={pDate}
                onChange={(e) => {
                  setPdate(e.target.value);
                }}
                className="form-control"                
                max={OldDate()}
                min="01-01-2000"
                required
              />
            </div>
            
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Pincode">Pincode:</label>
              <input
                name="Pincode"
                id="Pincode"
                value={Pincode}
                onChange={(e) => {
                  setPincode(e.target.value);
                }}
                className="form-control"
                cols=""
                rows=""
                placeholder="Enter Pincode"
                required
              ></input>
            </div>
            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Address">Full Address:</label>
              <textarea
                name="address"
                id="addres"
                value={Address}
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
                className="form-control"
                cols=""
                rows=""
                placeholder="Enter Full Address"
                required
              ></textarea>
            </div>

            <div className="form-group col-md-6 mt-4">
              <label htmlFor="Issue">Issue:</label>
              {/* <input type="Address" name="Address" className="form-control" placeholder="Enter Your Name"/> */}
              <textarea
                name="issue"
                id="issue"
                value={Issue}
                onChange={(e) => {
                  setIssue(e.target.value);
                }}
                className="form-control"
                cols=""
                rows=""
                placeholder="Enter Product Issue"
                required
              ></textarea>
            </div>
            <div
              className="form-group col-md-6 mt-4"
              style={{ display: 'none' }}
            >
              <label htmlFor="Name">ComplaintNumber:</label>
              <input
                type="text"
                name="ComplaintNumber"
                id="ComplaintNumber"
                value={complaintNumber}
                onChange={(e) => {
                  setComplaintNumber(e.target.value);
                }}
                className="form-control"
                placeholder="Enter Complaint Number"
                required
              />
              {/* <select name="setComplaintNumber" id="setComplaintNumber">
                <option value={complaintNumber} onChange={(e)=>{
                  setComplaintNumber(e.target.value)
                }} required>
                  Update
                </option>
              </select> */}
            </div>
          </div>
          <div style={{ textAlign: "center" }} className="row">
            <button
              type="button"
              className="btn btn-primary mt-4 mb-2"
              onClick={saveComplaint} disabled={name.length<3 || pNumber.length<10 || pNumber.length>10
              || aNumber.length>10||aNumber.length<10|| brandName.length<2 || modal.length<2||serialNumber.length<3|| Pincode.length<5||Address.length<15 || pDate.length<10}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
